export const statusCheck = async ({ status, json }, Router, loginWithRedirect, errorPageRedirect = false) => {
    if ([200, 201, 204].includes(status)) {
        return true;
    }

    if (status === 401) {
        const { message } = await json();

        if (message === 'invalid permissions') {
            return Router.push('/access-denied');
        }

        return loginWithRedirect();
    }

    if (errorPageRedirect) {
        return Router.push('/err');
    }
}
